/*!
 * Vimeo LazyLoad
 * v2.1.0
 * https://github.com/the-muda-organization/vimeo-lazyload
 * MIT License
 */

(function() {
  /********************************************************************
   ************************** MAIN VARIABLES ***************************
   *********************************************************************/
  let vimeo = document.querySelectorAll(".vi-lazyload"),
    vimeo_observer,
    template_wrap,
    template_content,
    template_playbtn,
    template_logo,
    template_iframe,
    settings_observer_rootMargin = "200px 0px";
  vimeo.length > 0;
  {
    //create elements
    template_wrap = document.createElement("div");
    template_content = document.createElement("div");
    template_playbtn = document.createElement("div");
    template_logo = document.createElement("a");
    template_iframe = document.createElement("iframe");

    //set attributes
    template_wrap.classList.add("vi-lazyload-wrap");
    template_content.classList.add("vi-lazyload-content");

    template_playbtn.classList.add("vi-lazyload-playbtn");

    template_logo.classList.add("vi-lazyload-logo");
    template_logo.target = "_blank";
    template_logo.rel = "noreferrer";

    /********************************************************************
     ********************* INTERSECTION OBSERVER API *********************
     *********************************************************************/
    vimeo_observer = new IntersectionObserver(
      function(elements) {
        elements.forEach(function(e) {
          //VARIABLES
          let this_element = e.target,
            this_wrap,
            this_content,
            this_playbtn,
            this_logo,
            this_iframe,
            this_data_id = e.target.dataset.id,
            this_data_embed = e.target.dataset.embed,
            this_data_thumb = e.target.dataset.thumb,
            this_data_logo = e.target.dataset.logo;

          //if element appears in viewport
          if (e.isIntersecting === true) {
            //wrap
            this_wrap = template_wrap.cloneNode();
            this_element.append(this_wrap);

            //content
            this_content = template_content.cloneNode();
            this_wrap.append(this_content);

            //background-image
            this_content.style.setProperty(
              "--vi-lazyload-img",
              'url("' + this_data_thumb + '")'
            );

            //play btn
            this_playbtn = template_playbtn.cloneNode();
            this_content.append(this_playbtn);

            //onclick create iframe
            this_playbtn.addEventListener("click", function() {
              this_content.innerHTML = this_data_embed;
            });

            //Unobserve after image lazyloaded
            vimeo_observer.unobserve(this_element);
          }
        });
      },
      {
        rootMargin: settings_observer_rootMargin
      }
    );

    /********************************************************************
     ********************* ITERATE THROUGH ELEMENTS **********************
     *********************************************************************/
    vimeo.forEach(function(e) {
      //Intersection Observer API - observe elements
      vimeo_observer.observe(e);
    });
  }
})();
